class AISuggestedScript {
	constructor(source = "") {
		this.source = source;
	}

	codeChunk() {
		return this.source;
	}
}

export default AISuggestedScript;
